// extracted by mini-css-extract-plugin
module.exports = {"inventory-input-container":"CustomCostInputModal_inventory-input-container__OY76t","react-select-container":"CustomCostInputModal_react-select-container__A9pxc"};